module.exports = __webpack_public_path__ + "static/media/symbol-sponsor_white.26525307.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/symbol-sponsor_white.svg
// module id = ./src/assets/images/symbol-sponsor_white.svg
// module chunks = 0